import { createFileRoute } from '@tanstack/react-router';

import { CartPage } from '@/features/shop/cart-page';

export const Route = createFileRoute('/_app/projects/$projectId/procurement/cart')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <CartPage {...params} />;
}
